import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';
import ReactGA from 'react-ga4';
import { QueryClientProvider } from 'react-query';

import './styles';
import browserHistory from './history';
import Router from './routes';
import store from './store';
import config from './config';
import queryClient from './query';

// lib produces verbose warnings that simply are not true
// comment this out to diagnose react-beautiful-dnd issues
window['__react-beautiful-dnd-disable-dev-warnings'] = true;

// Sentry Integration
Sentry.init(config.sentry);

// Google Analytics Integration
if (process.env.NODE_ENV === 'production' && !process.env.REACT_APP_TESTING) {
  ReactGA.initialize('G-W9S62PD8H7');
  browserHistory.listen(() => {
    ReactGA.set({ page: window.location.pathname });
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  });
}

ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <Router />
    </QueryClientProvider>
  </Provider>,
  document.getElementById('root')
);
